module.exports = __webpack_public_path__ + "assets/209d145d9d26d7f30b0c2bebcafb1feb.png";